export const DEFAULT_OG_IMAGE = '/images/logo.png';

export function resolveOgImage(origin: string, image?: string | null): string {
  const src = image?.trim();
  if (!src) return `${origin}${DEFAULT_OG_IMAGE}`;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  return `${origin}${src.startsWith('/') ? '' : '/'}${src}`;
}
